import React from "react";
import {
  Button,
  Row,
  Col,
  Popconfirm,
  notification,
  message,
  Spin,
  Input,
  Tooltip,
  Select,
  Divider,
  DatePicker,
  Radio,
  Table,
  Modal,
  Form,
} from "antd";
import { withRouter } from "react-router-dom";
import {
  CloseOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  LoadingOutlined,
  ReloadOutlined,
  SaveOutlined,
  SearchOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { axiosInstance } from "../../../commons/commons";
import {
  building,
  contacts,
  currency,
  division,
  legalCompany,
  project,
  unit,
  unitHandoverVacating,
  vwRentalCSRequest,
  vwRentalTcList,
} from "../../../constants/url";
import { decodedToken, stateStore } from "../../../constants/constants";

class UnitHandoverVacating extends React.Component {
  state = {
    dataIsLoading: false,
    dataBeingSaved: false,
    deletingComplaint: false,
    createUpdateDisabled: false,
    csrModalIsVisible: false,
    handoverVacatingData: {
      CSRID: null,
      SysCode: null,
      CSRNo: null,
      TCID: null,
      LegalCompany_ID: null,
      Division_ID: null,
      CurrencyID: null,
      CurrRate: 1,
      Remarks: null,
      CheckList: null,
      CSOperation: "CN",
      AssignedTo: null,
      Posted: false,
      selectedUnits: [],
      CSDate: moment(),
      VacatingDate: moment(),
      DateCreated: moment(),
      DateEdited: moment(),
      CreatedBy: null,
      EditedBy: null,
      SettlementRequestNo: null,
      SettlementRequestID: null,
    },
    companyData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    divisionData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    projectData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    buildingData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    unitData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    contractRefData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    employeeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    currencyData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    checklistData: {
      list: [],
    },
    vacatingStatus: {
      list: [],
    },
    tcUnits: { list: [], selectedRowKeys: [] },
    csrData: { list: [], loading: false },
    tenantData: {},
  };

  getInitialState = async () => {
    let state = {
      dataIsLoading: false,
      dataBeingSaved: false,
      deletingComplaint: false,
      createUpdateDisabled: false,
      csrModalIsVisible: false,
      handoverVacatingData: {
        CSRID: null,
        SysCode: null,
        CSRNo: null,
        TCID: null,
        LegalCompany_ID: null,
        Division_ID: null,
        CurrencyID: null,
        CurrRate: 1,
        Remarks: null,
        CheckList: null,
        CSOperation: "CN",
        AssignedTo: null,
        Posted: false,
        selectedUnits: [],
        CSDate: moment(),
        VacatingDate: moment(),
        DateCreated: moment(),
        DateEdited: moment(),
        CreatedBy: null,
        EditedBy: null,
        SettlementRequestNo: null,
        SettlementRequestID: null,
      },
      companyData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      divisionData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      projectData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      buildingData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      unitData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      contractRefData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      employeeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      currencyData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      checklistData: {
        list: [],
      },
      vacatingStatus: {
        list: [],
      },
      tcUnits: { list: [], selectedRowKeys: [] },
      csrData: { list: [], loading: false },
      tenantData: {},
    };
    await axiosInstance
      .get(legalCompany)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contacts + "?ContactCategoryID=1")
      .then((res) => {
        if (res.data.success) state.employeeData.list = res.data.message.rows;
      })
      .catch(() => {});
    await axiosInstance
      .get(currency)
      .then((res) => {
        if (res.data.success) state.currencyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(unitHandoverVacating + "/checklist?Vacating_HandOver=V")
      .then((res) => {
        if (res.data.success)
          state.checklistData.list = res.data.message.map(
            (checklist, index) => {
              checklist.key = index;
              checklist.SN = index + 1;
              checklist.UnitVacatingHandoverChecklist = {
                CheckListName: checklist.CheckListName,
              };
              return checklist;
            }
          );
      })
      .catch(() => {});
    await axiosInstance
      .get(unitHandoverVacating + "/status?Vacating_HandOver=V")
      .then((res) => {
        if (res.data.success) state.vacatingStatus.list = res.data.message;
      })
      .catch(() => {});
    return state;
  };

  initEditables = async (ID, mode) => {
    this.setState({
      dataIsLoading: true,
      dataBeingSaved: false,
      createUpdateDisabled: false,
    });
    let state = this.state;
    state.dataIsLoading = false;
    await axiosInstance
      .get(
        unitHandoverVacating +
          (mode === "settlement" ? "?SettlementRequestNo=" : "?CSRID=") +
          ID
      )
      .then((res) => {
        if (res.data.message) {
          state.handoverVacatingData = {
            ...state.handoverVacatingData,
            ...(res.data.message.rows[0] || {}),
          };
        }
      })
      .catch(() => {});
    state.handoverVacatingData.CSDate = moment(
      state.handoverVacatingData.CSDate
    );
    state.handoverVacatingData.VacatingDate = moment(
      state.handoverVacatingData.VacatingDate
    );
    state.currencyData.list.map((currency, index) => {
      if (currency.CurrencyID === state.handoverVacatingData.CurrencyID) {
        state.currencyData.selectedIndex = index;
        state.currencyData.selectedValue = currency.UserName;
      }
      return currency;
    });
    state.employeeData.list.map((contact, index) => {
      if (contact.ContactID === state.handoverVacatingData.AssignedTo) {
        state.employeeData.selectedIndex = index;
        state.employeeData.selectedValue = contact.ContactName;
      }
      return contact;
    });
    state.companyData.list.map((company, index) => {
      if (
        company.LegalCompanyID === state.handoverVacatingData.LegalCompany_ID
      ) {
        state.companyData.selectedIndex = index;
        state.companyData.selectedValue = company.CompanyName;
      }
      return company;
    });
    if (state.handoverVacatingData.LegalCompany_ID)
      await axiosInstance
        .get(
          division +
            "?LegalCompanyID=" +
            state.handoverVacatingData.LegalCompany_ID
        )
        .then((res) => {
          if (res.data.success)
            state.divisionData = {
              list: res.data.message,
              selectedIndex: null,
              selectedValue: null,
            };
        })
        .catch(() => {});
    state.divisionData.list.map((division, index) => {
      if (division.DivisionID === state.handoverVacatingData.Division_ID) {
        state.divisionData.selectedIndex = index;
        state.divisionData.selectedValue = division.UserName;
      }
      return division;
    });
    if (state.handoverVacatingData.TCID)
      await axiosInstance
        // .get(vwRentalTcList + "?TCID=" + state.handoverVacatingData.TCID)
        .post(vwRentalTcList, {
          where: { TCID: state.handoverVacatingData.TCID },
          attributes: ["ProjectID", "BuildingID", "UnitID"],
        })
        .then(async (res) => {
          if (res.data.success) {
            state.contractRefData = {
              list: res.data.message,
              selectedIndex: null,
              selectedValue: null,
            };
            state.tcUnits.list = (
              (res.data.message[0] || {}).RentalTCUnits || []
            ).map((unit, index) => {
              return {
                key: index,
                SN: index + 1,
                UnitID: unit.UnitID,
                UnitNo: unit.Unit.UnitNo,
              };
            });
            // state.contractRefData.list.map((ref, index) => {
            //   if (ref.TCID === state.handoverVacatingData.TCID) {
            //     state.contractRefData.selectedIndex = index;
            //     state.contractRefData.selectedValue = ref.TCNo;
            //     state.tenantData = { ...ref };
            //   }
            //   return ref;
            // });
            if (res.data.message.length)
              await axiosInstance
                .get(
                  unitHandoverVacating +
                    "/view?UnitID=" +
                    res.data.message[0].UnitID
                )
                .then((response) => {
                  if (response.data.success) {
                    let excludeTcs = response.data.message.map((tc) => tc.TCID);
                    state.contractRefData.list = state.contractRefData.list
                      .filter((refTc) => excludeTcs.includes(refTc.TCID))
                      .map((tc, index) => {
                        if (tc.TCID === state.handoverVacatingData.TCID) {
                          state.contractRefData.selectedIndex = index;
                          state.contractRefData.selectedValue = tc.TCNo;
                          state.tenantData = { ...tc };
                          // for calculting days
                          state.handoverVacatingData.TCFromDate = tc.TCFromDate;
                          state.handoverVacatingData.TCToDate = tc.TCToDate;
                        }
                        return tc;
                      });
                  }
                })
                .catch(() => {});
          }
        })
        .catch(() => {});
    await axiosInstance
      .get(
        unitHandoverVacating + "/unit?CSRID=" + state.handoverVacatingData.CSRID
        // (mode === "settlement" ? state.handoverVacatingData.CSRID : ID)
      )
      .then((res) => {
        if (res.data.success) {
          state.tcUnits.list.map((unit, index) => {
            for (let hUnit of res.data.message) {
              if (unit.UnitID === hUnit.UnitID) {
                state.tcUnits.selectedRowKeys = [
                  ...state.tcUnits.selectedRowKeys,
                  index,
                ];
                state.handoverVacatingData.selectedUnits = [
                  ...state.handoverVacatingData.selectedUnits,
                  unit.UnitID,
                ];
              }
            }
            return unit;
          });
        }
      })
      .catch(() => {});
    if (state.handoverVacatingData.Division_ID)
      await axiosInstance
        .get(project + "?DivisionID=" + state.handoverVacatingData.Division_ID)
        .then((res) => {
          if (res.data.success)
            state.projectData = {
              list: res.data.message,
              selectedIndex: null,
              selectedValue: null,
            };
        })
        .catch(() => {});
    state.projectData.list.map((project, index) => {
      if (project.ProjectID === state.tenantData.ProjectID) {
        state.projectData.selectedIndex = index;
        state.projectData.selectedValue = project.ProjectName;
      }
      return project;
    });
    if (state.tenantData.ProjectID)
      await axiosInstance
        .get(building + "?ProjectID=" + state.tenantData.ProjectID)
        .then((res) => {
          if (res.data.success)
            state.buildingData = {
              list: res.data.message,
              selectedIndex: null,
              selectedValue: null,
            };
        })
        .catch(() => {});
    state.buildingData.list.map((building, index) => {
      if (building.BuildingID === state.tenantData.BuildingID) {
        state.buildingData.selectedIndex = index;
        state.buildingData.selectedValue = building.BuildingName;
      }
      return building;
    });
    if (state.tenantData.BuildingID)
      await axiosInstance
        .get(unit + "?BuildingID=" + state.tenantData.BuildingID)
        .then((res) => {
          if (res.data.success)
            state.unitData = {
              list: res.data.message,
              selectedIndex: null,
              selectedValue: null,
            };
        })
        .catch(() => {});
    state.unitData.list.map((unit, index) => {
      if (unit.UnitID === state.tenantData.UnitID) {
        state.unitData.selectedIndex = index;
        state.unitData.selectedValue = unit.UnitNo;
      }
      return unit;
    });
    await axiosInstance
      .get(
        unitHandoverVacating +
          "/rental/checklist?CSRID=" +
          state.handoverVacatingData.CSRID
      )
      .then((res) => {
        if (res.data.success) {
          state.checklistData.list = state.checklistData.list.map(
            (checklist) => {
              for (let row of res.data.message) {
                if (row.CheckListId === checklist.CheckListId) {
                  checklist.StatusId = row.StatusId;
                  checklist.EstimatedValue = row.EstimatedValue;
                  break;
                }
              }
              return checklist;
            }
          );
        }
      })
      .catch(() => {});
    this.setState(state);
  };

  onChange = (value) => {
    if (!value) return;
    let state = this.state;
    let theIndex = value.split("+-")[1];
    let theValue = value.split("+-")[2];
    switch (value.split("+-")[0]) {
      case "adminCompany":
        state.handoverVacatingData.TCID = null;
        state.handoverVacatingData.LegalCompany_ID =
          state.companyData.list[theIndex].LegalCompanyID;
        // set company data and reset other
        state = {
          ...state,
          companyData: {
            list: state.companyData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
          divisionData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
            icon: theValue ? (
              <LoadingOutlined style={{ color: "#1890ff" }} />
            ) : null,
          },
          projectData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          buildingData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          unitData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          contractRefData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          tenantData: {},
        };
        this.setState(state, () => {
          state = this.state;
          state.handoverVacatingData.LegalCompany_ID =
            state.companyData.list[theIndex].LegalCompanyID;
          this.setState(state);
          if (theValue)
            axiosInstance
              .get(
                division +
                  "?LegalCompanyID=" +
                  state.companyData.list[theIndex].LegalCompanyID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    divisionData: {
                      list: res.data.message,
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
              })
              .catch(() => {
                this.setState({
                  divisionData: {
                    list: [],
                    selectedIndex: null,
                    selectedValue: null,
                  },
                });
              });
        });
        break;
      case "division":
        state.handoverVacatingData.TCID = null;
        state.handoverVacatingData.Division_ID =
          state.divisionData.list[theIndex].DivisionID;
        state = {
          ...state,
          divisionData: {
            list: state.divisionData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
          projectData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
            icon: theValue ? (
              <LoadingOutlined style={{ color: "#1890ff" }} />
            ) : null,
          },
          buildingData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          unitData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          contractRefData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          tenantData: {},
        };
        this.setState(state, () => {
          state = this.state;
          state.handoverVacatingData.Division_ID =
            state.divisionData.list[theIndex].DivisionID;
          this.setState(state);
          if (theValue)
            axiosInstance
              .get(
                project +
                  "?DivisionID=" +
                  state.divisionData.list[theIndex].DivisionID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    projectData: {
                      list: res.data.message,
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
              })
              .catch(() => {
                this.setState({
                  projectData: {
                    list: [],
                    selectedIndex: null,
                    selectedValue: null,
                  },
                });
              });
        });
        break;
      case "project":
        state.handoverVacatingData.TCID = null;
        state = {
          ...state,
          projectData: {
            list: state.projectData.list,
            selectedIndex: theIndex,
            selectedValue: theValue,
          },
          buildingData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
            icon: theValue ? (
              <LoadingOutlined style={{ color: "#1890ff" }} />
            ) : null,
          },
          unitData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          contractRefData: {
            list: [],
            selectedIndex: null,
            selectedValue: null,
          },
          tenantData: {},
        };
        this.setState(state, () => {
          state = this.state;
          state.handoverVacatingData.ProjectID =
            state.projectData.list[theIndex].ProjectID;
          this.setState(state);
          if (theValue)
            axiosInstance
              .get(
                building +
                  "?ProjectID=" +
                  state.projectData.list[theIndex].ProjectID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    buildingData: {
                      list: res.data.message,
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
              })
              .catch(() => {
                this.setState({
                  buildingData: {
                    list: [],
                    selectedIndex: null,
                    selectedValue: null,
                  },
                });
              });
        });
        break;
      case "building":
        state.handoverVacatingData.TCID = null;
        state.handoverVacatingData.BuildingID = // for backend code generation
          state.buildingData.list[theIndex].BuildingID;
        this.setState(
          {
            buildingData: {
              list: state.buildingData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            contractRefData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            tenantData: {},
          },
          () => {
            state = this.state;
            state.handoverVacatingData.BuildingID =
              state.buildingData.list[theIndex].BuildingID;
            this.setState(state);
            if (theValue) {
              axiosInstance
                .get(
                  unit +
                    "?BuildingID=" +
                    state.buildingData.list[theIndex].BuildingID +
                    "&RentalUnitStatusID=" +
                    (this.state.handoverVacatingData.CSOperation === "CS"
                      ? 1
                      : 2)
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      unitData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {
                  this.setState({
                    unitData: {
                      list: [],
                      selectedIndex: null,
                      selectedValue: null,
                    },
                  });
                });
            }
          }
        );
        break;
      case "unit":
        this.setState(
          {
            unitData: {
              list: state.unitData.list,
              selectedIndex: theIndex,
              selectedValue: theValue,
            },
            contractRefData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            tenantData: {},
          },
          () => {
            state = this.state;
            state.handoverVacatingData.UnitID =
              state.unitData.list[state.unitData.selectedIndex].UnitID;
            this.setState(state);
            if (theValue)
              axiosInstance
                .post(vwRentalTcList, {
                  where: {
                    LegalCompany_ID:
                      state.companyData.list[state.companyData.selectedIndex]
                        .LegalCompanyID,
                    BuildingID:
                      state.buildingData.list[state.buildingData.selectedIndex]
                        .BuildingID,
                    UnitID: state.unitData.list[theIndex].UnitID,
                  },
                  attributes: ["ProjectID", "BuildingID", "UnitID"],
                })
                .then(async (res) => {
                  state = this.state;
                  if (res.data.success) {
                    state.contractRefData = {
                      list: res.data.message,
                      selectedIndex: null,
                      selectedValue: null,
                    };
                    await axiosInstance
                      .get(
                        unitHandoverVacating +
                          "/view?UnitID=" +
                          this.state.unitData.list[
                            this.state.unitData.selectedIndex
                          ].UnitID
                      )
                      .then((response) => {
                        if (response.data.success) {
                          let excludeTcs = response.data.message.map(
                            (tc) => tc.TCID
                          );
                          state.contractRefData.list =
                            state.contractRefData.list.filter(
                              (refTc) => !excludeTcs.includes(refTc.TCID)
                            );
                        }
                      })
                      .catch(() => {});
                    // state.tenantData = {
                    //   ...(res.data.message[0] || {}),
                    // };
                    // state.handoverVacatingData.TCID = state.tenantData.TCID;
                  }
                  state.contractRefData.icon = null;
                  this.setState(state);
                })
                .catch(() => {});
          }
        );
        break;
      case "contract":
        state.contractRefData.selectedIndex = theIndex;
        state.contractRefData.selectedValue = theValue;
        state.tenantData = { ...(state.contractRefData.list[theIndex] || {}) };
        state.tcUnits.list = (state.tenantData.RentalTCUnits || []).map(
          (unit, index) => {
            return {
              key: index,
              SN: index + 1,
              UnitID: unit.UnitID,
              UnitNo: unit.Unit.UnitNo,
            };
          }
        );
        state.handoverVacatingData.TCID = state.tenantData.TCID;
        // for calculating days
        state.handoverVacatingData.TCFromDate = state.tenantData.TCFromDate;
        state.handoverVacatingData.TCToDate = state.tenantData.TCToDate;
        this.setState(state);
        break;
      case "currency":
        state.currencyData.selectedIndex = theIndex;
        state.currencyData.selectedValue = theValue;
        state.handoverVacatingData.CurrencyID =
          state.currencyData.list[theIndex].CurrencyID;
        this.setState(state);
        break;
      case "employee":
        state.employeeData.selectedIndex = theIndex;
        state.employeeData.selectedValue = theValue;
        state.handoverVacatingData.AssignedTo =
          state.employeeData.list[theIndex].ContactID;
        this.setState(state);
        break;
      default:
        break;
    }
  };

  validateWritable = async () => {
    let error = "";
    if (!this.state.companyData.selectedValue)
      error = "Please select a company !";
    if (!this.state.divisionData.selectedValue)
      error = "Please select a division !";
    if (!this.state.projectData.selectedValue)
      error = "Please select a project !";
    if (!this.state.buildingData.selectedValue)
      error = "Please select a building !";
    if (!this.state.unitData.selectedValue) error = "Please select an unit !";
    if (!this.state.contractRefData.selectedValue)
      error = "Please select TC Ref. !";
    if (!this.state.tcUnits.selectedRowKeys.length)
      error = "Please select at least one unit from contract units !";
    if (
      !this.state.handoverVacatingData.CurrRate ||
      Number(this.state.handoverVacatingData.CurrRate < 1)
    )
      error = "Please enter (valid) currency rate !";
    if (
      this.state.handoverVacatingData.CSOperation === "CN" &&
      !this.state.handoverVacatingData.SettlementRequestNo
    )
      error = "Please select/enter settlement request !";
    // new
    if (
      (this.state.unitData.list[this.state.unitData.selectedIndex] || {}).UnitID
    )
      await axiosInstance
        .get(
          unitHandoverVacating +
            "/view?UnitID=" +
            this.state.unitData.list[this.state.unitData.selectedIndex].UnitID +
            "&TCID=" +
            this.state.contractRefData.list[
              this.state.contractRefData.selectedIndex
            ].TCID
        )
        .then((res) => {
          if (res.data.success) {
            if (!this.state.handoverVacatingData.CSRID) {
              // new
              if (res.data.message.length)
                error =
                  "This Unit already exist with the same contract reference on DOC: " +
                  res.data.message[0].CSRNo;
            } else if (
              // update
              this.state.handoverVacatingData.CSRID !==
              res.data.message[0].CSRID
            ) {
              error =
                "This Unit already exist with the same contract reference on DOC: " +
                res.data.message[0].CSRNo;
            }
          }
        })
        .catch((err) => {});
    if (
      this.state.handoverVacatingData.CSRID &&
      this.state.handoverVacatingData.Posted
    )
      error =
        "Contract settlement request has been confirmed. Modification is not possible !";
    if (error) {
      message.error(error);
      return false;
    } else return true;
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((state) => {
      if (this._isMounted)
        this.setState(state, () => {
          if (this.props.location.state && this.props.location.state.CSRID)
            this.initEditables(this.props.location.state.CSRID);
        });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Handover Vacating</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}></Col>
        </Row>
        <Spin
          spinning={this.state.dataIsLoading}
          tip="Fetching and populating data..."
        >
          <Row>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Row>
                <Col span={24}>
                  <Divider style={{ marginTop: 0 }}>Property Info</Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Company</label>
                        </Col>
                        <Col span={17}>
                          <Select
                            showSearch
                            style={{ width: "100%" }}
                            placeholder="Select a Company"
                            optionFilterProp="children"
                            onChange={(val) =>
                              this.onChange(val || "adminCompany+-")
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            value={
                              this.state.companyData.selectedValue
                                ? "adminCompany+-" +
                                  this.state.companyData.selectedIndex +
                                  "+-" +
                                  this.state.companyData.selectedValue
                                : null
                            }
                          >
                            {this.state.companyData.list.map(
                              (company, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={
                                      "adminCompany+-" +
                                      index +
                                      "+-" +
                                      company.CompanyName
                                    }
                                  >
                                    {company.CompanyName}
                                  </Select.Option>
                                );
                              }
                            )}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Division</label>
                        </Col>
                        <Col span={17}>
                          <Select
                            showSearch
                            suffixIcon={this.state.divisionData.icon}
                            style={{ width: "100%" }}
                            placeholder="Select a Division"
                            optionFilterProp="children"
                            onChange={(val) =>
                              this.onChange(val || "division+-")
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            value={
                              this.state.divisionData.selectedValue
                                ? "division+-" +
                                  this.state.divisionData.selectedIndex +
                                  "+-" +
                                  this.state.divisionData.selectedValue
                                : null
                            }
                          >
                            {this.state.divisionData.list.map(
                              (division, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={
                                      "division+-" +
                                      index +
                                      "+-" +
                                      division.UserName
                                    }
                                  >
                                    {division.UserName}
                                  </Select.Option>
                                );
                              }
                            )}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Project</label>
                        </Col>
                        <Col span={17}>
                          <Select
                            showSearch
                            suffixIcon={this.state.projectData.icon}
                            style={{ width: "100%" }}
                            placeholder="Select a Project"
                            optionFilterProp="children"
                            onChange={(val) =>
                              this.onChange(val || "project+-")
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            value={
                              this.state.projectData.selectedValue
                                ? "project+-" +
                                  this.state.projectData.selectedIndex +
                                  "+-" +
                                  this.state.projectData.selectedValue
                                : null
                            }
                          >
                            {this.state.projectData.list.map(
                              (project, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={
                                      "project+-" +
                                      index +
                                      "+-" +
                                      project.ProjectName
                                    }
                                  >
                                    {project.ProjectName}
                                  </Select.Option>
                                );
                              }
                            )}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Building</label>
                        </Col>
                        <Col span={17}>
                          <Select
                            showSearch
                            suffixIcon={this.state.buildingData.icon}
                            style={{ width: "100%" }}
                            placeholder="Select a Building"
                            optionFilterProp="children"
                            onChange={(val) =>
                              this.onChange(val || "building+-")
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            value={
                              this.state.buildingData.selectedValue
                                ? "building+-" +
                                  this.state.buildingData.selectedIndex +
                                  "+-" +
                                  this.state.buildingData.selectedValue
                                : null
                            }
                          >
                            {this.state.buildingData.list.map(
                              (building, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={
                                      "building+-" +
                                      index +
                                      "+-" +
                                      building.BuildingName
                                    }
                                  >
                                    {building.BuildingName}
                                  </Select.Option>
                                );
                              }
                            )}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Unit</label>
                        </Col>
                        <Col span={17}>
                          <Select
                            showSearch
                            suffixIcon={this.state.unitData.icon}
                            style={{ width: "100%" }}
                            placeholder="Select a Unit"
                            optionFilterProp="children"
                            onChange={(val) => this.onChange(val || "unit+-")}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            value={
                              this.state.unitData.selectedValue
                                ? "unit+-" +
                                  this.state.unitData.selectedIndex +
                                  "+-" +
                                  this.state.unitData.selectedValue
                                : null
                            }
                          >
                            {this.state.unitData.list.map((unit, index) => {
                              return (
                                <Select.Option
                                  key={index}
                                  value={"unit+-" + index + "+-" + unit.UnitNo}
                                >
                                  {unit.UnitNo}
                                </Select.Option>
                              );
                            })}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>TC Ref.</label>
                        </Col>
                        <Col span={17}>
                          <Select
                            showSearch
                            suffixIcon={this.state.contractRefData.icon}
                            style={{ width: "100%" }}
                            placeholder="Select a Unit"
                            optionFilterProp="children"
                            onChange={(val) =>
                              this.onChange(val || "contract+-")
                            }
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            value={
                              this.state.contractRefData.selectedValue
                                ? "contract+-" +
                                  this.state.contractRefData.selectedIndex +
                                  "+-" +
                                  this.state.contractRefData.selectedValue
                                : null
                            }
                          >
                            {this.state.contractRefData.list.map(
                              (contract, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={
                                      "contract+-" +
                                      index +
                                      "+-" +
                                      contract.TCNo
                                    }
                                  >
                                    {contract.TCNo}
                                  </Select.Option>
                                );
                              }
                            )}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>TC No.</label>
                        </Col>
                        <Col span={17}>
                          <Input
                            placeholder="TCXXXX/XX/XX/XXXX"
                            value={this.state.tenantData.TCNo}
                            suffix={this.state.tenantData.icon}
                          ></Input>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Tenant</label>
                        </Col>
                        <Col span={17}>
                          <Input
                            placeholder="Tenant Name"
                            value={this.state.tenantData.Customer}
                            suffix={
                              this.state.tenantData.icon ||
                              this.state.tenantData.IsBlackListed ? (
                                <Tooltip title="Blacklisted">
                                  <WarningOutlined
                                    style={{ color: "red" }}
                                    className="blacklist"
                                  />
                                </Tooltip>
                              ) : null
                            }
                          ></Input>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Tenant Contact</label>
                        </Col>
                        <Col span={8}>
                          <Input
                            placeholder="Phone"
                            value={this.state.tenantData.TenantContactNo}
                            suffix={this.state.tenantData.icon}
                          ></Input>
                        </Col>
                        <Col span={9}>
                          <Input
                            placeholder="Email"
                            value={this.state.tenantData.TenantEmail}
                            suffix={this.state.tenantData.icon}
                          ></Input>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={6}
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Row style={{ marginBottom: 10 }} gutter={8}>
                        <Col span={6} style={{ textAlign: "right" }}>
                          <label>Contract Date</label>
                        </Col>
                        <Col span={8}>
                          <Input
                            placeholder="From"
                            value={
                              (this.state.tenantData.TCFromDate || "").split(
                                "T"
                              )[0] || ""
                            }
                            suffix={this.state.tenantData.icon}
                          ></Input>
                        </Col>
                        <Col span={9}>
                          <Input
                            placeholder="To"
                            value={
                              (this.state.tenantData.TCToDate || "").split(
                                "T"
                              )[0] || ""
                            }
                            suffix={this.state.tenantData.icon}
                          ></Input>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Row>
                <Col span={24}>
                  <Divider style={{ marginTop: 0 }}>Detail</Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>System No.</label>
                    </Col>
                    <Col span={17}>
                      <Input value={this.state.handoverVacatingData.SysCode} />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Doc. No.</label>
                    </Col>
                    <Col span={17}>
                      <Input
                        value={this.state.handoverVacatingData.CSRNo}
                        onChange={(e) => {
                          let state = this.state;
                          state.handoverVacatingData.CSRNo = e.target.value;
                          this.setState(state);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Doc. Date</label>
                    </Col>
                    <Col span={17}>
                      <DatePicker
                        format="YYYY-MM-DD"
                        style={{ width: "100%" }}
                        value={this.state.handoverVacatingData.CSDate}
                        onChange={(date) => {
                          let state = this.state;
                          state.handoverVacatingData.CSDate = date;
                          this.setState(state);
                        }}
                      ></DatePicker>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Handover/Vacating Date</label>
                    </Col>
                    <Col span={17}>
                      <DatePicker
                        format="YYYY-MM-DD"
                        style={{ width: "100%" }}
                        value={this.state.handoverVacatingData.VacatingDate}
                        onChange={(date) => {
                          let state = this.state;
                          state.handoverVacatingData.VacatingDate = date;
                          this.setState(state);
                        }}
                      ></DatePicker>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Doc Type</label>
                    </Col>
                    <Col span={17}>
                      <Radio.Group
                        value={this.state.handoverVacatingData.CSOperation}
                        onChange={(e) => {
                          let state = this.state;
                          state.handoverVacatingData.CSOperation =
                            e.target.value;
                          this.setState(state);
                        }}
                      >
                        <Radio key="CS" value="CS">
                          Handover
                        </Radio>
                        <Radio key="CN" value="CN">
                          Vacating
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Currency</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="Select a currency"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "currency+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.currencyData.selectedValue
                            ? "currency+-" +
                              this.state.currencyData.selectedIndex +
                              "+-" +
                              this.state.currencyData.selectedValue
                            : null
                        }
                      >
                        {this.state.currencyData.list.map((currency, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "currency+-" + index + "+-" + currency.UserName
                              }
                            >
                              {currency.UserName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Rate</label>
                    </Col>
                    <Col span={17}>
                      <Input
                        type="number"
                        placeholder="Rate"
                        value={this.state.handoverVacatingData.CurrRate}
                        onChange={(e) => {
                          let state = this.state;
                          state.handoverVacatingData.CurrRate = e.target.value;
                          this.setState(state);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Assigned To</label>
                    </Col>
                    <Col span={17}>
                      <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="Select an employee"
                        optionFilterProp="children"
                        onChange={(val) => this.onChange(val || "employee+-")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={
                          this.state.employeeData.selectedValue
                            ? "employee+-" +
                              this.state.employeeData.selectedIndex +
                              "+-" +
                              this.state.employeeData.selectedValue
                            : null
                        }
                      >
                        {this.state.employeeData.list.map((employee, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={
                                "employee+-" +
                                index +
                                "+-" +
                                employee.ContactName
                              }
                            >
                              {employee.ContactName}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Remarks</label>
                    </Col>
                    <Col span={17}>
                      <Input.TextArea
                        rows={1}
                        value={this.state.handoverVacatingData.Remarks}
                        onChange={(e) => {
                          let state = this.state;
                          state.handoverVacatingData.Remarks = e.target.value;
                          this.setState(state);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Checklist</label>
                    </Col>
                    <Col span={17}>
                      <Input.TextArea
                        rows={1}
                        value={this.state.handoverVacatingData.CheckList}
                        onChange={(e) => {
                          let state = this.state;
                          state.handoverVacatingData.CheckList = e.target.value;
                          this.setState(state);
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col
              span={6}
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 8 }}
            >
              <Row>
                <Col span={24}>
                  <Divider style={{ marginTop: 0 }}>CheckLists</Divider>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <label>Settlement Req. Ref.</label>
                    </Col>
                    <Col
                      span={15}
                      xs={{ span: 16 }}
                      sm={{ span: 16 }}
                      md={{ span: 16 }}
                      lg={{ span: 15 }}
                    >
                      <Input
                        rows={1}
                        value={
                          this.state.handoverVacatingData.SettlementRequestNo
                        }
                        onChange={(e) => {
                          let state = this.state;
                          state.handoverVacatingData.SettlementRequestNo =
                            e.target.value;
                          this.setState(state);
                        }}
                        suffix={
                          <EllipsisOutlined
                            onClick={() => {
                              this.setState({ csrModalIsVisible: true });
                            }}
                          />
                        }
                      />
                    </Col>
                    <Col
                      span={3}
                      xs={{ span: 2 }}
                      sm={{ span: 2 }}
                      md={{ span: 2 }}
                      lg={{ span: 3 }}
                    >
                      <Tooltip title="Refresh">
                        <div>
                          <Button
                            disabled={
                              !this.state.handoverVacatingData
                                .SettlementRequestNo
                            }
                            icon={<ReloadOutlined />}
                            style={{ width: "100%" }}
                            onClick={() => {
                              this.initEditables(
                                this.state.handoverVacatingData
                                  .SettlementRequestNo,
                                "settlement"
                              );
                            }}
                          ></Button>
                        </div>
                      </Tooltip>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={24}>
                      <Table
                        dataSource={this.state.checklistData.list}
                        columns={[
                          {
                            title: "S.N",
                            dataIndex: "SN",
                            key: "SN",
                            align: "center",
                            fixed: "left",
                            width: 50,
                          },
                          {
                            title: "Item",
                            dataIndex: [
                              "UnitVacatingHandoverChecklist",
                              "CheckListName",
                            ],
                            key: "CheckListName",
                            align: "center",
                            width: 100,
                            sorter: (a, b) =>
                              a.UnitVacatingHandoverChecklist.CheckListName.localeCompare(
                                b.UnitVacatingHandoverChecklist.CheckListName
                              ),
                          },
                          {
                            title: "Status",
                            dataIndex: "UnitVacatingHandoverStatus",
                            key: "StatusName",
                            align: "center",
                            width: 100,
                            render: (_, item) => (
                              <Select
                                showSearch
                                style={{ width: "100%" }}
                                placeholder="Select an status"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(value) => {
                                  if (
                                    this.state.handoverVacatingData
                                      .CSOperation === "CS"
                                  )
                                    return;
                                  let state = this.state;
                                  state.checklistData.list =
                                    state.checklistData.list.map(
                                      (checklist) => {
                                        if (
                                          item.CheckListId ===
                                          checklist.CheckListId
                                        ) {
                                          checklist.StatusId = value;
                                        }
                                        return checklist;
                                      }
                                    );
                                  state.handoverVacatingData.checklistData = [
                                    ...state.checklistData.list,
                                  ];
                                  this.setState(state);
                                }}
                                value={item.StatusId}
                              >
                                {this.state.vacatingStatus.list.map(
                                  (status, index) => {
                                    return (
                                      <Select.Option
                                        key={index}
                                        value={status.StatusID}
                                      >
                                        {status.StatusName}
                                      </Select.Option>
                                    );
                                  }
                                )}
                              </Select>
                            ),
                          },
                          {
                            title: "Estimated Value",
                            dataIndex: "EstimatedValue",
                            key: "EstimatedValue",
                            align: "center",
                            width: 100,
                            sorter: (a, b) =>
                              a.EstimatedValue - b.EstimatedValue,
                            render: (_, item) => (
                              <Input
                                type="number"
                                onChange={(e) => {
                                  if (
                                    this.state.handoverVacatingData
                                      .CSOperation === "CS"
                                  )
                                    return;
                                  let state = this.state;
                                  state.checklistData.list =
                                    state.checklistData.list.map(
                                      (checklist) => {
                                        if (
                                          item.CheckListId ===
                                          checklist.CheckListId
                                        ) {
                                          checklist.EstimatedValue =
                                            e.target.value;
                                        }
                                        return checklist;
                                      }
                                    );
                                  state.handoverVacatingData.checklistData = [
                                    ...state.checklistData.list,
                                  ];
                                  this.setState(state);
                                }}
                                value={item.EstimatedValue}
                              />
                            ),
                          },
                        ]}
                        scroll={{ y: 140 }}
                        pagination={false}
                      ></Table>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  <Row style={{ marginBottom: 10 }} gutter={8}>
                    <Col span={24}>
                      <Table
                        dataSource={this.state.tcUnits.list}
                        columns={[
                          {
                            title: "S.N",
                            dataIndex: "SN",
                            key: "SN",
                            align: "center",
                            fixed: "left",
                            width: 50,
                          },
                          {
                            title: "UnitNo",
                            dataIndex: "UnitNo",
                            key: "UnitNo",
                            align: "center",
                            width: 100,
                            sorter: (a, b) => a.UnitNo.localeCompare(b.UnitNo),
                          },
                        ]}
                        rowSelection={{
                          selectedRowKeys: this.state.tcUnits.selectedRowKeys,
                          onChange: (selectedRowKeys) => {
                            let state = this.state;
                            state.tcUnits.selectedRowKeys = selectedRowKeys;
                            state.handoverVacatingData.selectedUnits =
                              state.tcUnits.list
                                .map((unit, index) => {
                                  if ((selectedRowKeys || []).includes(index))
                                    return unit.UnitID;
                                  return null;
                                })
                                .filter(Boolean);
                            this.setState(state);
                          },
                        }}
                        scroll={{ y: 70 }}
                        pagination={false}
                      ></Table>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Spin>
        <Row
          gutter={8}
          style={{
            marginTop: 20,
            marginBottom: 10,
          }}
        >
          <Col
            span={6}
            xs={{ span: 12 }}
            sm={{ span: 8 }}
            md={{ span: 10 }}
            lg={{ span: 10 }}
          >
            <Spin spinning={this.state.dataBeingSaved} tip="">
              <Button
                icon={<SaveOutlined style={{ color: "green" }} />}
                style={{ width: "100%", borderRadius: 20 }}
                disabled={this.state.createUpdateDisabled}
                onClick={async () => {
                  if (await this.validateWritable()) {
                    let state = this.state;
                    state.createUpdateDisabled = true;
                    this.setState(state);
                    state.createUpdateDisabled = false;
                    (!this.state.handoverVacatingData.CSRID
                      ? axiosInstance.post(
                          unitHandoverVacating,
                          this.state.handoverVacatingData
                        )
                      : axiosInstance.put(
                          unitHandoverVacating,
                          this.state.handoverVacatingData
                        )
                    )
                      .then((res) => {
                        if (res.data.success) {
                          if (res.data.CSRID) {
                            notification.success({
                              message: "Success",
                              description: res.data.message,
                            });
                            this.setState(state, () =>
                              this.initEditables(res.data.CSRID)
                            );
                          } else {
                            notification.success({
                              message: "Success",
                              description: res.data.message,
                            });
                          }
                        } else {
                          notification.error({
                            message: "Fail",
                            description: "Something went wrong !",
                          });
                        }
                        this.setState(state);
                      })
                      .catch((err) => {
                        this.setState(state);
                        notification.error({
                          message: "Error",
                          description: err.message,
                        });
                      });
                  }
                }}
              >
                {this.state.handoverVacatingData.CSRID ? "Update" : "Create"}
              </Button>
            </Spin>
          </Col>
          <Col
            span={6}
            xs={{ span: 12 }}
            sm={{ span: 8 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
          >
            <Button
              icon={<SearchOutlined />}
              style={{
                width: "100%",
                borderRadius: 20,
              }}
              disabled={
                decodedToken.value.activeKey === "employee" &&
                decodedToken.value.User_ID !== 1 &&
                stateStore.permissions[74] &&
                stateStore.permissions[74].UView === "N"
              }
              onClick={() =>
                stateStore.navAble
                  ? stateStore.navAble({
                      defaultSelectedKeys: ["handoverVacatingView"],
                      routableProps: { caller: "handoverVacating" },
                    })
                  : null
              }
            >
              Find
            </Button>
          </Col>
          <Col
            span={6}
            xs={{ span: 24 }}
            sm={{ span: 0 }}
            md={{ span: 0 }}
            lg={{ span: 0 }}
            style={{ marginTop: 10 }}
          ></Col>
          <Col
            span={6}
            xs={{ span: 12 }}
            sm={{ span: 4 }}
            md={{ span: 4 }}
            lg={{ span: 4 }}
          >
            <Button
              icon={<CloseOutlined style={{ color: "purple" }} />}
              style={{ width: "100%", borderRadius: 20 }}
              onClick={() => {
                this.getInitialState().then((state) => this.setState(state));
              }}
            >
              Reset
            </Button>
          </Col>
          <Col
            span={6}
            xs={{ span: 12 }}
            sm={{ span: 4 }}
            md={{ span: 4 }}
            lg={{ span: 4 }}
          >
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={(e) => {
                if (
                  decodedToken.value.User_ID !== 1 &&
                  (!stateStore.permissions[74] ||
                    stateStore.permissions[74].UDelete === "N")
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                if (this.state.handoverVacatingData.CSRID) {
                  this.setState({
                    deletionDisabled: true,
                    deletingComplaint: true,
                  });
                  axiosInstance
                    .delete(
                      unitHandoverVacating +
                        "/" +
                        this.state.handoverVacatingData.CSRID
                    )
                    .then((res) => {
                      if (res.data.success) {
                        this.getInitialState().then((state) =>
                          this.setState(state)
                        );
                        notification.success({
                          message: "Success",
                          description: "Deleted!",
                        });
                      } else
                        notification.error({
                          message: "Fail",
                          description:
                            res.data.message || "Something went wrong!",
                        });
                      this.setState({
                        deletionDisabled: false,
                        deletingComplaint: false,
                      });
                    })
                    .catch(() => {
                      this.setState({
                        deletionDisabled: false,
                        deletingComplaint: false,
                      });
                    });
                }
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Spin spinning={this.state.deletingComplaint} tip="">
                <Button
                  icon={<DeleteOutlined style={{ color: "red" }} />}
                  style={{
                    width: "100%",
                    borderRadius: 20,
                  }}
                  disabled={
                    !this.state.handoverVacatingData.CSRID ||
                    this.state.deletionDisabled
                  }
                >
                  Delete
                </Button>
              </Spin>
            </Popconfirm>
          </Col>
          <Col
            span={6}
            xs={{ span: 24 }}
            sm={{ span: 0 }}
            md={{ span: 0 }}
            lg={{ span: 0 }}
            style={{ marginTop: 10 }}
          ></Col>
          <Col
            span={6}
            xs={{ span: 6 }}
            sm={{ span: 0 }}
            md={{ span: 0 }}
            lg={{ span: 0 }}
          ></Col>
        </Row>
        <Modal
          title={"Contract Settlement"}
          visible={this.state.csrModalIsVisible}
          onCancel={() => this.setState({ csrModalIsVisible: false })}
          bodyStyle={{
            padding: 0,
            paddingBottom: 10,
            maxHeight: window.innerHeight - 150,
            overflowY: "scroll",
          }}
          footer={null}
        >
          <Row>
            <Col span={24} style={{ padding: 10, paddingBottom: 0 }}>
              <Form
                requiredMark
                layout="horizontal"
                colon={false}
                ref={(ref) => (ref ? (this.formRef = ref) : null)}
                // fields={this.state.editFormFields}
              >
                <Form.Item
                  key="CSRNo"
                  name="CSRNo"
                  label="CSRNo"
                  labelAlign="left"
                  labelCol={{ span: 4 }}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item
                  key="BuildingName"
                  name="BuildingName"
                  label="Building"
                  labelAlign="left"
                  labelCol={{ span: 4 }}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item
                  key="UnitNo"
                  name="UnitNo"
                  label="UnitNo"
                  labelAlign="left"
                  labelCol={{ span: 4 }}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item
                  key="CSRID"
                  name="CSRID"
                  label="CSRID"
                  labelAlign="left"
                  labelCol={{ span: 4 }}
                >
                  <Input></Input>
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col span={24}>
              <Button
                style={{ width: "100%" }}
                onClick={() => {
                  this.formRef
                    .validateFields()
                    .then((values) => {
                      let query = "?";
                      query += Object.keys(values)
                        .map((key) => {
                          if (values[key]) return key + "=" + values[key];
                          return null;
                        })
                        .filter(Boolean)
                        .join("&");
                      this.setState({
                        csrData: { ...this.state.csrData, loading: true },
                      });
                      axiosInstance
                        .get(vwRentalCSRequest + query)
                        .then((res) => {
                          if (res.data.success) {
                            this.setState({
                              csrData: {
                                list: res.data.message,
                                loading: false,
                              },
                            });
                          }
                        })
                        .catch(() => {
                          this.setState({
                            csrData: { ...this.state.csrData, loading: false },
                          });
                        });
                    })
                    .catch((err) => {});
                }}
                icon={<SearchOutlined />}
              >
                Search
              </Button>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Table
                dataSource={this.state.csrData.list}
                columns={[
                  {
                    title: "CSRNo",
                    dataIndex: "CSRNo",
                    key: "CSRNo",
                    align: "center",
                    width: 100,
                    sorter: (a, b) =>
                      (a.CSRNo || "").localeCompare(b.CSRNo || ""),
                  },
                  {
                    title: "Building",
                    dataIndex: "BuildingName",
                    key: "BuildingName",
                    align: "center",
                    width: 100,
                    sorter: (a, b) =>
                      (a.BuildingName || "").localeCompare(
                        b.BuildingName || ""
                      ),
                  },
                  {
                    title: "UnitNo",
                    dataIndex: "UnitNo",
                    key: "UnitNo",
                    align: "center",
                    width: 100,
                    sorter: (a, b) =>
                      (a.UnitNo || "").localeCompare(b.UnitNo || ""),
                  },
                  {
                    title: "CSRID",
                    dataIndex: "CSRID",
                    key: "CSRID",
                    align: "center",
                    width: 100,
                    sorter: (a, b) => (a.CSRID || 0) - (b.CSRID || 0),
                  },
                ]}
                onRow={(record, _) => {
                  return {
                    onDoubleClick: () => {
                      let state = this.state;
                      state.csrModalIsVisible = false;
                      state.csrData.selectedRow = record;
                      state.handoverVacatingData.SettlementRequestNo =
                        record.CSRNo;
                      this.setState(state, () =>
                        this.initEditables(record.CSRNo, "settlement")
                      );
                    },
                  };
                }}
                scroll={{ y: 300 }}
                pagination={false}
                loading={this.state.csrData.loading}
              ></Table>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default withRouter(UnitHandoverVacating);
